import { faSearch } from '@fortawesome/pro-regular-svg-icons'
import { Flex, Tag } from 'antd'
import isNil from 'lodash.isnil'
import { twMerge } from 'tailwind-merge'

import { ColorToken } from 'src/constants/theme/types'
import { useCurrentBreakpoint } from 'src/hooks/use-current-breakpoint'
import { useTheme } from 'src/hooks/use-theme'

import Input from '../Input/Input'
import { T } from '../Text/Text'

type Props = {
  actions?: React.ReactNode
  colorToken?: ColorToken
  count?: number // Only shown if title is non-null
  onSearchQueryChange?: (value: string) => void
  searchInputPlaceholder?: string
  searchInputRef?: React.Ref<HTMLInputElement>
  searchQuery?: string
  subtitle?: React.ReactNode
  title?: React.ReactNode
  wrap?: 'wrap' | 'nowrap'
}
const Header = ({
  actions,
  colorToken,
  count,
  onSearchQueryChange,
  searchInputPlaceholder = 'Search',
  searchInputRef,
  searchQuery = '',
  subtitle,
  title,
  wrap,
}: Props) => {
  const { isSmallScreen } = useCurrentBreakpoint()
  const { getTokenVal } = useTheme()
  const titleNode = (() => {
    if (!title) {
      return null
    }
    if (typeof title === 'string') {
      return (
        <T.H3
          className="m-0"
          {...(colorToken
            ? {
                style: {
                  color: getTokenVal(colorToken),
                },
              }
            : {})}
        >
          {title}
        </T.H3>
      )
    }
    return title
  })()
  const subtitleNode = (() => {
    if (!subtitle) {
      return null
    }
    if (typeof subtitle === 'string') {
      return (
        <T.Body
          {...(colorToken
            ? {
                style: {
                  color: getTokenVal(colorToken),
                },
              }
            : {})}
        >
          {subtitle}
        </T.Body>
      )
    }
    return subtitle
  })()

  return (
    <header
      className={twMerge(
        'flex items-center justify-between gap-3',
        wrap === 'wrap' || isSmallScreen() ? 'flex-wrap' : 'flex-nowrap'
      )}
    >
      <Flex align="center" gap="12px" wrap="wrap">
        {!!titleNode && (
          <Flex vertical align="start" gap="4px">
            <Flex gap="8px" align="center">
              {titleNode}
              {!isNil(count) && (
                <Tag color="default" style={{ margin: 0 }}>
                  {count}
                </Tag>
              )}
            </Flex>
            {subtitleNode}
          </Flex>
        )}
        {onSearchQueryChange && (
          <Input
            ariaLabel="Search input"
            isClearable
            placeholder={searchInputPlaceholder}
            prefixIcon={faSearch}
            ref={searchInputRef}
            value={searchQuery}
            onValueChange={onSearchQueryChange}
            width={isSmallScreen() ? '100%' : '240px'}
          />
        )}
      </Flex>
      <Flex flex={1} gap="8px" justify="flex-end" wrap="wrap">
        {actions}
      </Flex>
    </header>
  )
}

export default React.memo(Header)
